import { IAPIAction, ITemplateHistoryAction } from "interfaces";
import { TemplatesHistory } from "constants/Actions";

const {
  GET_TEMPLATES,
  GET_TEMPLATES_SUCCESS,
  GET_TEMPLATES_FAIL,
  GET_TEMPLATE_DATA,
  GET_TEMPLATE_DATA_SUCCESS,
  GET_TEMPLATE_DATA_FAIL,
  ADD_NEW_PAGE,
  ADD_NEW_PAGE_SUCCESS,
  ADD_NEW_PAGE_FAIL,
  DELETE_PAGE,
  INIT_TEMPLATES,
  GET_DOCUMENT_TYPES,
  GET_DOCUMENT_TYPES_SUCCESS,
  GET_DOCUMENT_TYPES_FAIL,
  IMPORT_TEMPLATE_DATA,
  SET_PAGE_PROPERTIES,
  UPDATE_TEMPLATE_DATA,

  SAVE_TEMPLATE_DATA,
  SAVE_TEMPLATE_DATA_SUCCESS,
  SAVE_TEMPLATE_DATA_FAIL,

  FILTER_TEMPLATES,

  COPY_TEMPLATE,
  COPY_TEMPLATE_SUCCESS,
  COPY_TEMPLATE_FAIL,
  COPY_TEMPLATE_COMPLETED,

  HANDLE_CONFIRM_EXIT_MODAL,

  SELECT_TEMPLATE,

  SORT_TEMPLATES,

  GET_TEMPLATE_VERSIONS_HISTORY,
  GET_TEMPLATE_VERSIONS_HISTORY_SUCCESS,
  GET_TEMPLATE_VERSIONS_HISTORY_FAIL,
  
  RESET_TEMPLATE_VERSIONS_HISTORY
} = TemplatesHistory;

export const templatesHistory: Readonly<IAPIAction & ITemplateHistoryAction> = {
  pages: {
    addNewPage: (data) => ({
      type: ADD_NEW_PAGE,
      payload: {
        data,
        isLoading: true,
      },
    }),
    setProperties: (data) => ({
      type: SET_PAGE_PROPERTIES,
      payload: {
        data,
        isLoading: true,
      },
    }),
    deletePage: (data) => ({
      type: DELETE_PAGE,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: ADD_NEW_PAGE_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: ADD_NEW_PAGE_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  templates: {
    init: (data) => ({
      type: INIT_TEMPLATES,
      payload: {
        data,
        isLoading: true,
      },
    }),
    get: (data) => ({
      type: GET_TEMPLATES,
      payload: {
        data,
        isLoading: true,
      },
    }),
    filter: (data) => ({
      type: FILTER_TEMPLATES,
      payload: {
        data,
        isLoading: false,
      },
    }),
    sort: (data) => ({
      type: SORT_TEMPLATES,
      payload: {
        data,
        isLoading: false,
      },
    }),
    success: (data) => ({
      type: GET_TEMPLATES_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: GET_TEMPLATES_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  documentTypes: {
    get: (data) => ({
      type: GET_DOCUMENT_TYPES,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: GET_DOCUMENT_TYPES_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: GET_DOCUMENT_TYPES_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  template: {
    get: (data) => ({
      type: GET_TEMPLATE_DATA,
      payload: {
        data,
        isLoading: true,
      },
    }),
    update: (data) => ({
      type: UPDATE_TEMPLATE_DATA,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: GET_TEMPLATE_DATA_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: GET_TEMPLATE_DATA_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
    import: (data) => ({
      type: IMPORT_TEMPLATE_DATA,
      payload: {
        data,
        isLoading: true,
      },
    }),
    select: (data) => ({
      type: SELECT_TEMPLATE,
      payload: {
        data,
        isLoading: true,
      },
    }),
  },
  templateData: {
    save: (data) => ({
      type: SAVE_TEMPLATE_DATA,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: SAVE_TEMPLATE_DATA_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: SAVE_TEMPLATE_DATA_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
    handleModal: (data) => ({
      type: HANDLE_CONFIRM_EXIT_MODAL,
      payload: {
        data,
        isLoading: false,
      },
    }),
  },
  templateCopy: {
    get: (data) => ({
      type: COPY_TEMPLATE,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: COPY_TEMPLATE_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: COPY_TEMPLATE_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
    complete: (data) => ({
      type: COPY_TEMPLATE_COMPLETED,
      payload: {
        data,
        isLoading: false,
      },
    }),
  },
  templateVersions: {
    get: (data) => ({
      type: GET_TEMPLATE_VERSIONS_HISTORY,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: GET_TEMPLATE_VERSIONS_HISTORY_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: GET_TEMPLATE_VERSIONS_HISTORY_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
    reset: (data) => ({
      type: RESET_TEMPLATE_VERSIONS_HISTORY,
      payload: {
        data,
        isLoading: true,
      },
    }),
  },
};
